/**
 * The workspace Overview as gadgets (design "Flow Workspace", Overview): the same machinery as the project Home
 * (utils/homeGadgetsModel.js), with its own catalog and its own place in the browser (`flow.workspaceGadgets`), the same
 * on every workspace. Credits are not a gadget: the gateway keeps them per person, not per workspace, so there is nothing
 * true to show.
 */
import { createGadgetsModel } from './homeGadgetsModel';

export const WORKSPACE_GADGETS = [
  { id: 'projects', label: 'Projects', desc: 'Each project: its state, who owns it, Open.', size: 'M' },
  { id: 'attention', label: 'Needs attention', desc: 'Failed builds and quality checks that block Publish, across projects.', size: 'S' },
  { id: 'latest', label: 'Latest across projects', desc: 'What happened last, with the project on each line.', size: 'M' },
  { id: 'members', label: 'Members', desc: 'Who is in the workspace and with which role.', size: 'S' },
  { id: 'brain', label: 'Workspace Brain', desc: 'Shared notes every project\'s agent reads.', size: 'S' },
];

export const workspaceGadgetsModel = createGadgetsModel({ gadgets: WORKSPACE_GADGETS, key: 'flow.workspaceGadgets', event: 'flow:workspace-gadgets-changed' });
